export const TermsService = () => {

    const styles = `
     @layer base {
            .legal-content h2 {
                @apply font-display font-bold text-2xl uppercase tracking-tight mt-10 mb-4 text-slate-900 dark:text-white border-l-4 border-primary pl-4;
            }
            .legal-content h3 {
                @apply font-bold text-lg uppercase tracking-wider mt-8 mb-3 text-slate-800 dark:text-slate-100;
            }
            .legal-content p {
                @apply mb-4 text-slate-600 dark:text-slate-400 leading-tight text-[15px];
            }
            .legal-content ul {
                @apply mb-6 space-y-2;
            }
            .legal-content li {
                @apply flex gap-3 text-slate-600 dark:text-slate-400 text-[15px] leading-tight;
            }
        }
        .summary-box {
            background: linear-gradient(135deg, rgba(249, 115, 22, 0.05) 0%, rgba(249, 115, 22, 0.02) 100%);
        }
`;

    return (
        <>

            <style type="text/tailwindcss">{styles}</style>

            <main class="py-16 md:py-24">
                <div class="max-w-4xl mx-auto px-4 sm:px-6">
                    <div class="mb-12 text-center">
                        <h1 class="text-4xl md:text-6xl font-display font-bold text-slate-900 dark:text-white uppercase mb-4">
                            Terms of <span class="text-primary">Service</span></h1>
                        <p class="text-slate-500 uppercase tracking-[0.3em] text-xs font-bold">Last Updated: October 2024</p>
                    </div>
                    <div class="summary-box border-2 border-primary/20 p-8 rounded-lg mb-16 relative overflow-hidden">
                        <div class="absolute top-0 right-0 p-4 opacity-10">
                            <span class="material-symbols-outlined text-8xl text-primary">assignment_turned_in</span>
                        </div>
                        <h2 class="font-display text-2xl font-bold uppercase text-primary mb-6">Summary of Key Clauses</h2>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                            <div class="flex items-start gap-3">
                                <span class="material-symbols-outlined text-primary font-bold">check_circle</span>
                                <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">All products are for
                                    individual or retail resale only. Wholesale requires special accounts.</p>
                            </div>
                            <div class="flex items-start gap-3">
                                <span class="material-symbols-outlined text-primary font-bold">check_circle</span>
                                <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">Shipping takes 5-10 business
                                    days for domestic orders via Om Clothing Co. logistics.</p>
                            </div>
                            <div class="flex items-start gap-3">
                                <span class="material-symbols-outlined text-primary font-bold">check_circle</span>
                                <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">Returns must be initiated
                                    within 14 days of receipt in original condition.</p>
                            </div>
                            <div class="flex items-start gap-3">
                                <span class="material-symbols-outlined text-primary font-bold">check_circle</span>
                                <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">Limited liability for
                                    industrial wear and tear post-purchase usage.</p>
                            </div>
                        </div>
                    </div>
                    <div class="legal-content">
                        <h2 id="section1">1. Acceptance of Terms</h2>
                        <p>By accessing and using the website of Flacon Jeans (operated by Om Clothing Co.), you agree to be
                            bound by these Terms of Service and all applicable laws and regulations. If you do not agree with
                            any of these terms, you are prohibited from using or accessing this site.</p>
                        <h2 id="section2">2. Use License</h2>
                        <p>Permission is granted to temporarily download one copy of the materials (information or software) on
                            Flacon Jeans' website for personal, non-commercial transitory viewing only.</p>
                        <h3>2.1 Restrictions</h3>
                        <ul>
                            <li><span class="text-primary font-bold">01.</span> Modify or copy the industrial denim designs or
                                proprietary patterns.</li>
                            <li><span class="text-primary font-bold">02.</span> Use the materials for any commercial purpose, or
                                for any public display (commercial or non-commercial).</li>
                            <li><span class="text-primary font-bold">03.</span> Attempt to decompile or reverse engineer any
                                software contained on the Flacon Jeans website.</li>
                        </ul>
                        <h2 id="section3">3. Manufacturing Standards &amp; Variations</h2>
                        <p>Our denim products are manufactured in our Asmeeta Textile Park facility. Due to the industrial
                            nature of denim washing and dyeing processes, slight variations in color, distress patterns, and
                            texture are inherent to the product and do not constitute manufacturing defects.</p>
                        <p>All measurements provided in sizing charts are approximate. We strive for precision, but a tolerance
                            of +/- 0.5 inches is standard in high-grade denim production.</p>
                        <h2 id="section4">4. Orders &amp; Payments</h2>
                        <p>All orders placed through the website are subject to acceptance by Om Clothing Co. We reserve the
                            right to refuse any order you place with us. In the event that we make a change to or cancel an
                            order, we may attempt to notify you by contacting the e-mail and/or billing address/phone number
                            provided at the time the order was made.</p>
                        <h2 id="section5">5. Intellectual Property</h2>
                        <p>The "FJ" logo, "Flacon Jeans" name, and all related industrial designs, imagery, and branding are the
                            exclusive property of Om Clothing Co. Use of our intellectual property without express written
                            consent is strictly prohibited and will be pursued to the fullest extent of the law.</p>
                        <h2 id="section6">6. Governing Law</h2>
                        <p>Any claim relating to Flacon Jeans' website shall be governed by the laws of the State of
                            Maharashtra, India, without regard to its conflict of law provisions. Jurisdiction for any legal
                            proceedings shall lie exclusively in the courts of Kalyan/Bhiwandi.</p>
                        <div class="mt-20 pt-10 border-t border-slate-200 dark:border-slate-800 text-center">
                            <p class="text-slate-400 text-sm">For questions regarding these terms, contact our legal department
                                at <span class="text-primary font-bold">legal@flaconjeans.com</span></p>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}